import React from 'react'
import Slider from 'infinite-react-carousel'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../Buttons'
import mobly from './mobly.png'
import flexform from './flexform.png'
import { Body, Container } from './styles'

export default function () {
  const { t } = useTranslation(['landing-page'])
  const settings = {
    // arrows: false,
    arrowsBlock: false,
    dots: true,
  }

  const quotes = [
    {
      logo: mobly,
      text: 'cases.mobly.text',
      person: 'cases.mobly.person',
      position: 'cases.mobly.position',
      cta: true,
    },
    {
      logo: flexform,
      text: 'cases.flexform.text',
      person: 'cases.flexform.person',
      position: 'cases.flexform.position',
      cta: false,
    },
  ]

  return (
    <Container>
      <Body>
        <section className="cases-section">
          <div className="title">
            <h1>{t('cases.title')}</h1>
            <span>{t('cases.description')}</span>
          </div>
          <div className="quotes-container">
            <Slider {...settings}>
              {quotes.map((quote) => (
                <div key={quote.text}>
                  <div className="background">
                    <img src={quote.logo} alt="Mobly" />
                    <div className="text">
                      {/* eslint-disable-next-line react/jsx-no-literals */}
                      <span className="quotes">“</span>
                      <span>{t(quote.text)}</span>
                      {/* eslint-disable-next-line react/jsx-no-literals */}
                      <span className="quotes">”</span>
                    </div>
                    <div className="person">
                      <span>
                        <b>{t(quote.person)}</b>
                      </span>
                      <span>{t(quote.position)}</span>
                    </div>
                  </div>
                  {quote.cta ? (
                    <div className="cta">
                      <Button type="primary">
                        <Link to="/mobly">
                          <span>{t('cases.cta')}</span>
                        </Link>
                      </Button>
                    </div>
                  ) : null}
                </div>
              ))}
            </Slider>
          </div>
        </section>
      </Body>
    </Container>
  )
}
